<template>
    <div :class="['editable-cell', background ? 'bg' : 'none']">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input-number 
            style="width: 100%;"
            :step="step"
            :autoFocus="true"
            :max="max"
            class="text"
            :min="min || 0"
            size="small"
            v-model="val"
            @blur="blur"
            @pressEnter="e => e.target.blur()"
            :precision='precision ? precision : 4'
          />
            <!-- :formatter="limitDecimalsF"
            :parser="limitDecimalsP" -->
        </div>
        <div class="editable-cell-text-wrapper" :class="color"  @click="edit" v-else>
          <a-spin :spinning="loading" size="small" class="spinning-block">
            <span :class="color">
              {{ text === '' || text === null || text === undefined ? text : Number(text || 0).toFixed(len)}}
            </span>
          </a-spin>
        </div>
    </div>
</template>

<script>
export default {
  props:['text','item', 'name', 'actions','background','len','precision','min','max'],
  data(){
    return {
      val:undefined,
      target:null,
      editable:false,
      loading:false,
      isEdit: false
    }
  },
  computed:{
    color(){
      const {item,name,text} = this
      const {content,percentage,maxLimitValue,minLimitValue,maxValue,minValue,mixPercentage} = item
      let contentVal = content === '' || content === null ? content : Number(content).toFixed(this.len)
      if(mixPercentage || mixPercentage === 0){
        contentVal = mixPercentage === '' || mixPercentage === null ? mixPercentage : Number(mixPercentage).toFixed(this.len)
      }
      const val =  text === '' || text === null ? text : Number(text).toFixed(this.len)
      const red = (val === contentVal || text === percentage) && (
        (name === 'maxLimitValue' && maxLimitValue !== '') ||
        (name === 'maxValue' && maxValue !== '')
        )
      const green = (val === contentVal || text === percentage) && ((name === 'minValue' && minValue !== '') || (name === 'minLimitValue' && minLimitValue !== ''))

      return {
        red,green,redBg:red,greenBg:green,blue: this.isEdit
      }
    },

    defaultText(){
      const textValue = this.text === '' || this.text === null ? this.text : Number(this.text).toFixed(3)
      return textValue
    },
    step(){
      const num = [1,0.1,0.01,0.001,0.0001]
      return num[this.len]
    },
    unit(){
      return this.len
    },
    // step(){
    //   // const normalUnit = this.item.rawName ? 0.001 : 0.01
    //   const normalUnit = this.item.rawName ? 0.0001 : 0.0001
    //   let units = normalUnit
    //   units = this.item.unit === 'Kcal' || this.item.unit === 'MJ' && ( this.name ==='minLimitValue' || this.name === 'maxLimitValue' || this.name === 'maxValue' || this.name === 'minValue' || this.name === 'content')
    //   ? 0 : normalUnit
    //   if(this.name === 'price') units = 0.001
    //   return units
    // },

    // nuit(){
    //   // const normalUnit = this.item.rawName ? 3 : 2
    //   const normalUnit = this.item.rawName ? 4 : 4
    //   let units = normalUnit
    //   units = this.item.unit === 'Kcal' || this.item.unit === 'MJ' && ( this.name ==='minLimitValue' || this.name === 'maxLimitValue' || this.name === 'maxValue' || this.name === 'minValue' || this.name === 'content')
    //   ? 0 : normalUnit
    //   if(this.name === 'price') units = 3
    //   return units
    // },
  },
  methods:{
  limitDecimalsF(value){
    let reg = /^(-)*(\d+)\.(\d\d).*$/;
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '').replace(reg,'$1$2.$3');
  },
  limitDecimalsP(value){
    let reg = /^(-)*(\d+)\.(\d\d).*$/;
    return value.replace(/\s?|(,*)/g, '').replace(reg,'$1$2.$3');
  },
  blur(){
      this.editable = false
      let target = {...this.item}
      if(this.text === this.val || (this.val === null && this.text === '')) return
      if(this.checkValue(this.val)){
        if(this.val < 0 && this.name === 'price'){
          this.$message.warn('价格不能为负数')
        }
        if(target[this.name] !== this.val || this.val === ''){
          target[this.name] = this.name === 'price' ? Number(this.val).toFixed(3) : this.val
          this.target = target
          this.$nextTick(()=>{
            this.updates()
          })
        }
      }
    },
    checkValue(val){
      const {name,item} = this
      if(val === null){
        return true
      } else if((name==="minLimitValue" && val > item.maxLimitValue && (item.maxLimitValue || item.maxLimitValue === 0))
      || (name==="maxLimitValue" && item.minLimitValue > val) 
      || (name==="maxValue" && item.minValue > val) 
      || (name==="minValue" && val > item.maxValue && (item.maxValue || item.maxValue === 0))) {
        this.errorMessage()
        return false
      } else {
        return true
      }
    },
    async updates(){
      this.target={...this.target,name:''}
      this.$nextTick(async() => {
        if(this.actions){
          this.loading = true
          await this.actions(this.target,true)
          this.loading = false
          
          this.$emit('blur',this.target)
        } else {
          this.loading = false
          this.$emit('blur',this.target)
        }
      })
    },
    change(val){
      this.val = val
    },
    edit(){
      if(this.item.isRawDelete != 1){
        this.editable = true
        this.isEdit = true
        this.val = this.text === '' || this.text === null ? this.text : Number(this.text).toFixed(this.len)
      }
    },
    errorMessage(){
      const msg = this.name ==='minLimitValue' || this.name === 'maxLimitValue' ? '极下限不能大于极上限' :'最小值不能大于最大值'
      this.$message.warn(msg)
    }
  }
  }
</script>
